import * as React from "react";
import { useEffect } from "react";
import ReactHtmlParser from 'react-html-parser';

export interface Step {
    title: string;
    formName: string;
}

export interface StepsProps {
    steps: Step[];
    activeStepFormName : string;
    extraSteps: Step[];
    cssClass? : string;
}

export const Steps = (props: StepsProps) => {
    let stepLength = props.steps.length + props.extraSteps.length;
    let width = Math.floor(100 / stepLength);
    let formStepCheckmark = "form-steps__step--checkmark";
    useEffect(() => {
        document.body.classList.add("has-step-indicator");
        return () => {
            document.body.classList.remove("has-step-indicator");
        };
    }, [props.steps]);

    // We need to check if there are extraSteps, as they are used in counting
    // Also we need to add 1, because arrays start at 0, and the first step is 1.
    let addToIndex = 1 + props.extraSteps.length;
    for (let i = 0; i < props.steps.length; i++) {
        if(props.steps[i].formName === props.activeStepFormName) {
            width = Math.floor(100 / stepLength * (i + addToIndex));
        }
    }


    return <>
        <div className={"form-steps " + (props.cssClass ? props.cssClass : "")}>
            <ol className="container form-steps__list" style={{'--width': `${width}%`}}>
                {props.extraSteps.map((step : Step, index) => <li key={"extra-step" + index} 
                            className={"form-steps__step form-steps__step--checkmark"}>
                        {ReactHtmlParser(step.title)}
                        </li>
                    )
                }
                {props.steps.map((step : Step, index) => {
                    if (step.formName === props.activeStepFormName) {
                        formStepCheckmark = "";
                    }
                    return <li key={"step" + index} data-formtab={step.formName} 
                            className={"form-steps__step " + formStepCheckmark + " " + (step.formName === props.activeStepFormName ? "active" : "")}>
                        {ReactHtmlParser(step.title)}
                        </li>;
                })
                }
            </ol>
            <div className="form-steps__numbers">
                <span className="form-steps__pretext">Stap</span>
                {props.steps.map((step : Step, index) => {
                    if (step.formName === props.activeStepFormName) {
                        return (
                            <span key={"step" + index} data-formtab={step.formName} 
                                className={"form-steps__step active"}>
                                {index + addToIndex}
                            </span>
                        )
                    }})
                }
                <span className="form-steps__aftertext">&nbsp;/&nbsp;</span>
                <span className="form-steps__aftertext">{stepLength}</span>
            </div>
        </div>
        <div className="form-steps__backgroundskew"></div>
    </>;
};